import { visionApi } from "../api/vision";

async function ScanCanvas(userKey: number | null | undefined, token: string | null | undefined, canvas: HTMLCanvasElement) {
    if (!userKey || !token) {
        console.error("User key or token not found in ScanCanvas");
        return null;
    }

    //const base64Image = frontCanvas.toDataURL('image/png');
    const base64Image = canvas.toDataURL("image/jpeg", 0.9);

    try {
        // Call the API which calls the Vision API with the image data
        const response = await visionApi.scanCard(
            userKey,
            token,
            base64Image
        );

        if (typeof response === "string") {
            try {
              const parsedResponse = JSON.parse(response);
              console.log("Card data from vision:");
              console.log(JSON.parse(response));
              return parsedResponse;
            } catch (jsonError) {
                console.error("JSON parse error:", jsonError);
                return null;
            }
        } else {
            console.error("Unexpected response type:", typeof response, response);
            return null;
        }
    } catch (error) {
        console.error("Error sending canvas data to /cardScan:", error);
        return null;
    }
}

export default ScanCanvas;
